<template>
    <Index></Index>
</template>

<script>
import Index from "@/page/Index.vue";

export default {
    name: 'App',
    components: {Index}
}
</script>

<style>

</style>
